<h2 mat-dialog-title>{{ headline | translate }}</h2>
<mat-dialog-content>
  @if (text.length > 0) {
    <p>{{ text | translate }}</p>
  }
  <mat-form-field>
    <mat-label>
      {{ label | translate }}
    </mat-label>
    <mat-select [(ngModel)]="option">
      @for (option of options; track $index) {
        <mat-option [value]="option.option">{{
          option.label | translate
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose>
    {{ "components.input-dialog.cancel" | translate }}
  </button>
  <button mat-button matDialogClose (click)="afterOptionSelected()">
    {{ "components.select-dialog.apply" | translate }}
  </button>
</mat-dialog-actions>
